import { render, staticRenderFns } from "./GradeStepAdd.vue?vue&type=template&id=4bd0fdf5&scoped=true"
import script from "./GradeStepAdd.vue?vue&type=script&lang=js"
export * from "./GradeStepAdd.vue?vue&type=script&lang=js"
import style0 from "./GradeStepAdd.vue?vue&type=style&index=0&id=4bd0fdf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0fdf5",
  null
  
)

export default component.exports